import { REDUCERS_NAME } from '../../constants';
import { createActionName } from '../../utility';

export const reducerName = REDUCERS_NAME.COURRIERS_DEPARTURE;

export const COURRIERS_DEPARTURE = createActionName(reducerName, 'COURRIERS_DEPARTURE');
export const DELETE_COURRIERS_DEPARTURE = createActionName(reducerName, 'DELETE_COURRIERS_DEPARTURE');
export const CREATE_COURRIERS_DEPARTURE = createActionName(reducerName, 'CREATE_COURRIERS_DEPARTURE');
export const UPDATE_COURRIERS_DEPARTURE = createActionName(reducerName, 'UPDATE_COURRIERS_DEPARTURE');
